import * as _ from 'underscore'
import { IID as IID_MvcStudio, ID as ID_MvcStudio } from 'mappMvcStudio/const'

export interface IID extends IID_MvcStudio {
	MAppsTable: string;
	MAppsTileGrid: string; 
}; 

export var ID: IID = _.extend({}, ID_MvcStudio, {
	MAppsTable: 'table',
	MAppsTileGrid: 'tilegrid' 
});